const Pools = () => (
    <svg
        width='33'
        height='34'
        viewBox='0 0 33 34'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M12.8334 16.1155C12.8334 14.3727 14.2772 12.9467 16.0418 12.9467C17.8064 12.9467 19.2501 14.3727 19.2501 16.1155C19.2501 17.8583 17.8064 19.2842 16.0418 19.2842C14.2772 19.2842 12.8334 17.8583 12.8334 16.1155ZM9.30423 25.1464L6.89797 22.9283L9.30423 20.5517C8.50214 19.2842 8.02089 17.6998 8.02089 16.1155C8.02089 14.5311 8.50214 12.9467 9.30423 11.8377L6.89797 9.46109L9.30423 7.08453L11.5501 9.46109C12.8334 8.66891 14.4376 8.1936 16.0418 8.1936C17.646 8.1936 19.2501 8.66891 20.5335 9.46109L22.9397 7.08453L25.1856 9.30266L22.7793 11.6792C23.5814 12.9467 24.0627 14.5311 24.0627 16.1155C24.0627 17.6998 23.5814 19.2842 22.7793 20.5517L25.1856 22.9283L22.9397 25.1464L20.5335 22.7698C19.2501 23.562 17.646 24.0373 16.0418 24.0373C14.4376 24.0373 12.8334 23.562 11.7105 22.7698L9.30423 25.1464M16.0418 11.3623C13.3147 11.3623 11.2292 13.422 11.2292 16.1155C11.2292 18.8089 13.3147 20.8686 16.0418 20.8686C18.7689 20.8686 20.8543 18.8089 20.8543 16.1155C20.8543 13.422 18.7689 11.3623 16.0418 11.3623ZM28.8752 0.271729C30.6398 0.271729 32.0836 1.69766 32.0836 3.44048V28.7905C32.0836 30.5333 30.6398 31.9592 28.8752 31.9592H27.271V33.5436H20.8543V31.9592H11.2292V33.5436H4.81253V31.9592H3.20836C1.44376 31.9592 0 30.5333 0 28.7905V3.44048C0 1.69766 1.44376 0.271729 3.20836 0.271729H28.8752ZM28.8752 28.7905V3.44048H3.20836V28.7905H28.8752Z'
            fill='url(#paint0_linear_1001_3552)'
        />
        <defs>
            <linearGradient
                id='paint0_linear_1001_3552'
                x1='0'
                y1='16.9076'
                x2='32.0836'
                y2='16.9077'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
        </defs>
    </svg>
);

export default Pools;
